export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS'
export const GET_ALERTS_FAILURE = 'GET_ALERTS_FAILURE'
export const MARK_ALERT_READ_SUCCESS = 'MARK_ALERT_READ_SUCCESS'
export const MARK_ALERT_READ_FAILURE = 'MARK_ALERT_READ_FAILURE'
export const CLEAR_ALERT_SUCCESS = 'CLEAR_ALERT_SUCCESS'
export const CLEAR_ALERT_FAILURE = 'CLEAR_ALERT_FAILURE'
export const CLEAR_ALL_ALERTS_SUCCESS = 'CLEAR_ALL_ALERTS_SUCCESS'
export const CLEAR_ALL_ALERTS_FAILURE = 'CLEAR_ALL_ALERTS_FAILURE'
